 var offers=[
    {
        name: "软件工程师（后端、初级）",
        address: [1, 2],
        kind1: 1,
        money: "6-33K",
        skills: [
            "负责服务端代码编写。",
            "负责基础通信相关服务的设计与开发。",
            "负责 API 设计文档的撰写。",
        ],
        describe: [
            "计算机、通信、电子等相关专业本科及以上，1年以上Java Web开发经验。",
            "熟悉数据结构，有扎实的 Java 基础，熟练使用 Spring、SpringMVC、MyBatis等框架。",
            "熟练使用常用数据存储组件，比如mysql、oracle、redis等。",
            "具备前端开发能力者优先。",
        ]
    }, {
        name: "软件工程师（后端、中级）",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责服务端代码编写。",
            "需求分析，编写对应文档。",
            "负责通信相关服务的设计与开发。",
            "负责 API 设计文档的撰写。"
        ],
        describe: [
            "计算机、通信、电子等相关专业本科及以上学历，3年以上Java Web开发经验。",
            "有扎实的 Java 基础，熟悉 Spring、SpringMVC、MyBatis、SpringBoot等框架的使用和原理。",
            "熟悉Netty、Grpc等网络编程库优先。",
            " 熟练使用常用数据存储组件，比如mysql、oracle、redis等，对原理有所了解。",
            "有 IoT 服务开发经验的优先。"
        ]

    },
    {
        name: "软件工程师（后端、高级）",
        address: [1, 2],
        kind1: 1,
        money: "9-42K",
        skills: [
            " 参与技术方案和系统设计评审。把握复杂系统的设计，确保系统的架构质量。",
            "系统核心部分代码编写。解决疑难问题。",
            "为团队引入创新的技术、创新的解决方案，用创新的思路解决问题。",
            "负责 API 分析业务需求，撰写技术方案和系统设计。"
        ],
        describe: [
            "计算机、通信、电子等相关专业本科及以上学历，5年以上Java Web开发经验。",
            "熟悉java语言，对集合、IO、多线程、反射、jvm等有清晰的理解，对JDK源码有一定了解。",
            "熟悉spring，mybatis，springboot等成熟框架的使用和原理，阅读过部分源码。",
            "熟练使用常用数据存储组件，比如mysql、redis、MongDB等，对原理有所了解，能够独立设计数据结构。",
            "有分布式系统开发经验，对微服务、集群、RPC、CAP、分布式事务等一定的理解。",
            "熟练使用主流消息队列，如Kafka、RabbitMQ等，对底层原理有了解。",
            "熟悉公有云服务优先，如阿里云、AWS。",
            "有 IoT 服务开发经验的优先。"
        ]

    },

    {
        name: "软件工程师（前端、初级）",
        address: [1, 2],
        kind1: 1,
        money: "6-33K",
        skills: [
            "负责公司产品的Web前端开发/维护工作。",
            "独立负责项目的开发、调试、修改工作。",
            "负责与设计、后台开发人员等保持良好沟通，快速理解、消化各方需求，并落实为具体的开发工作。",
        ],
        describe: [
            "计算机相关专业本科及以上学历，1年以上相关经验。",
            "熟悉前端基础技能，熟练使用HTML5、CSS3、JavaScript(ES6)等前端技术。",
            "熟练使用 Chrome 的开发者工具。",
            "熟悉MVVM和MVC模式、异步编程以及响应式开发等概念。",
            "熟悉node.js者优先。"
        ]
    },
    {
        name: "软件工程师（前端、中级）",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责PC及移动端APP产品的前端代码开发工作，撰写相关技术文档。",
            "负责对产品页面性能的优化和维护，持续提升用户体验。",
            "负责公司其他项目的前端开发。",
        ],
        describe: [
            "计算机相关专业本科及以上学历，3年以上相关经验。",
            "精通HTML5、CSS3、JAVASCRIPT等Web前端开发技术，可以独立完成前端代码。",
            "对VueJS或ReactJS有深入了解，熟练运用Echart/HighCharts或其他可视化库。",
            "熟悉主流浏览器的跨平台兼容性与 web 性能优化的解决方案。",
            "具备java或node.js服务端开发能力，熟练使用Sass/Less者优先。"
        ]
    },
    {
        name: "软件工程师（前端、高级）",
        address: [1, 2],
        kind1: 1,
        money: "9-42K",
        skills: [
            "根据产品经理的关键需求进行前端架构设计工作。",
            "承担前端核心模块的设计、实现，对代码质量及进度负责。",
            "参与进行关键技术验证以及技术选型工作。",
            "与后台开发工程师配合，完成开发任务和上线。"
        ],
        describe: [
            "计算机相关专业本科及以上学历，5年以上相关经验。",
            "精通HTML、CSS、JavaScript语言，了解HTML5、CSS3的新标准，熟悉JQuery类库，熟练使用前端调试工具。",
            "至少熟练掌握Vue、React、AngularJS其中一种JS框架。",
            "深刻理解Web标准，对前端性能、可访问性、可维护性等相关知识有实际的了解和实践经验。",
        ]
    },
    {
        name: "嵌入式测试工程师",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责终端平台、软件测试工作。",
            "完成测试流程、测试计划、测试方案的制定、实施和跟踪。",
            "负责相关测试文档记录。",
        ],
        describe: [
            "本科及以上学历，计算机、电子或自动化等相关专业。3年以上终端平台软件测试工作经验。",
            "精通终端系统黑盒和白盒测试。",
            "熟悉硬件设计，能够独立查看原理图。",
            "熟悉ARM平台裸机和Linux操作系统软件测试，精通Shell脚本编程，熟悉Android者优先。"
        ]
    },
    {
        name: "嵌入式软件工程师（Linux）",
        address: [1],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责嵌入式平台Linux系统各个组件的定制、裁剪。",
            "配合驱动开发工程师、硬件工程师，进行硬件调试。",
            "配合应用开发工程师，进行软件移植调试。",
            "负责编写Linux系统开发文档，维护各个嵌入式平台Linux系统源码。"
        ],
        describe: [
            "计算机、电子、自动化等相关专业本科及以上学历，5年以上嵌入式平台Linux系统定制相关经验。",
            "熟悉Linux系统启动流程，熟悉uboot/kernel/devicetree/filesyste等移植流程。",
            "有良好的硬件基础，熟悉各种硬件接口，能够根据原理图进行板卡调试。",
            "熟悉yocto/petelinux/buildroot等linux系统定制工具。",
            "精通软件移植，熟悉cmake/configure/make等软件移植工具。"
        ]
    },
    {
        name: "嵌入式软件工程师（应用）",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责嵌入式平台的软件设计、开发、测试工作。",
            "与硬件、测试及其他软件团队沟通，配合软硬件测试。",
            "参与编写、维护开发文档，设计测试用例。",
        ],
        describe: [
            "计算机、电子或自动化等相关专业本科及以上学历，3年以上嵌入式软件开发工作经验。",
            "熟悉嵌入式平台裸机、操作系统（Linux、uCOS等）软件开发流程、开发环境。",
            "有良好的硬件基础，熟悉各种硬件接口，能够根据原理图进行板卡调试。",
            "精通C/C++语言，扎实的计算机软件基础（数据结构、算法、操作系统、数据库原理等）。",
            "熟悉常用外设接口（uart/i2c/usb）通信、网络编程。",
            "熟悉线程间通信、进程间通信。",
            "有音视频开发经验，熟悉音视频原始格式（RGB/YUV/PCM等），熟悉常用音视频压缩格式(MJPG/H.264等)，熟悉gstreamer视频架构者优先。",
            "熟悉QT编程，有QT程序开发经验者优先。",
            "精通软件移植，熟悉cmake/configure/make等软件移植工具。"
        ]
    },
    {
        name: "机器人算法工程师（导航）",
        address: [2],
        kind1: 1,
        money: "9-42K",
        skills: [
            "使用多源传感器开发基于不同依据的高精度定位模块，用于自动驾驶高精度定位。",
            "使用视觉和 Lidar 技术建立定位模块使用的高精度地图。",
            "综合使用相关知识，完成大规模自动化的多源传感器标定。",
            "负责自动驾驶车多传感器融合定位算法的研发，和导航决策与路径规划工作。"
        ],
        describe: [
            "电子、通信、自动化、计算机等相关专业本科及以上学历。",
            "了解常用 vSLAM，VO/VIO 或 LiDAR SLAM 算法。",
            "熟悉 GPS 卫星定位原理，具有融合 GPS、IMU 及里程计等多种设备的定位算法研发经验，掌握多传感器数据融合、姿态解算及惯性导航。",
            "熟悉 Kalman、粒子滤波等常用融合算法，熟悉自动驾驶汽车相关路径规划与决策。",
            "Kaggle、Robocon、RoboMaster、恩智浦杯智能车竞赛等赛事获奖者优先 。",
        ]
    },
    {
        name: "硬件工程师（初级）",
        address: [1, 2],
        kind1: 1,
        money: "7-36K",
        skills: [
            "负责公司产品的硬件BOM文件整理、核对和维护，PCBA信号测试。",
            "负责公司产品硬件生产资料的编撰，下发，生产异常解析。",
            " 配合软件工程师进行相关的测试验证。",
            "负责撰写产品维修手册和使用说明。"
        ],
        describe: [
            "电子、计算机、电气自动化、通信等相关专业本科及以上学历，1年以上相关开发经验。",
            "熟悉模电、数电、射频电路等相关基本原理知识，熟练掌握电子元器件特性。",
            "熟练使用Cadence、AD或PADS其中一种画图软件。",
            "解PCB制造和SMT生产相关知识。",
        ]
    },

    {
        name: "系统工程师",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            " 负责智能终端系统或智能机器人的系统架构分析。",
            "对终端，算法，后台，Web端都熟悉，并能根据产品需求，绘制架构图以及开发流程图。",
            "负责撰写产品详细开发设计文档，并负责各模块集成问题。",
            "领域覆盖通信/设备/算法//应用框架等。"
        ],
        describe: [
            "本科及以上学历，5年以上相关工作经验。",
            "电子、通信、自动化、计算机等相关专业本科及以上学历。",
            "有多年人工智能和智能终端的系统架构工作经验。",
            "熟悉 C/C++， Linux，JAVA, Python语言，并至少精通一种。",
        ]
    },
    {
        name: "嵌入式软件工程师（算法）",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责嵌入式平台的算法移植、优化工作。",
            "与硬件、软件与算法团队沟通，配合算法嵌入式终端部署。",
            "参与编写、维护开发文档，管理嵌入式平台算法源码。",
        ],
        describe: [
            " 计算机、电子或自动化等相关专业，本科及以上学历。3年以上嵌入式平台（单片机、ARM、DSP）软件开发相关经验。",
            "熟悉主流搭载NPU的SoC平台，熟悉常见AI加速模组。",
            "精通C/C++语言，扎实的计算机软件基础（数据结构、算法、操作系统、数据库原理等）。",
            "熟悉ARM Cotex-A/Cortex-M架构，了解主流深度学习网络，了解java语言。",
            "有如下经验者优先：汇编语言代码优化经验，嵌入式平台算法或网络模型移植经验，有JNI接口开发经验。"
        ]
    },
    {
        name: "硬件工程师（高级）",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责公司产品的硬件核心器件的选型，原理图审核，PCB审核，PCBA信号测试方案的制定与测试报告审核，硬件issue追踪与分析。",
            "负责硬件产品的可靠性测试，EMC以及安规认证等相关事宜。",
            "负责硬件产品成本管控和生产可行性审核。",
            "负责沟通解决PCB制造，SMT生产和产品组装过程中的异常。"
        ],
        describe: [
            "电子、计算机、电气自动化、通信等相关专业本科及以上学历，5年以上硬件相关开发经验。",
            "熟悉模电、数电、射频电路，电源电路，高速电路等原理知识。",
            "精通IO/BUS的测试规范，如USB，I2C，I2S，MIPI，HDMI，SDIO，UART，RS232/485等。",
            "熟练使用Cadence、AD或PADS其中一种画图软件，熟悉高速信号布线规则，有4层及以上多层PCB板布线经验优先。",
            "精通PCB，FPC制程，熟悉业界通用标准。",
            "有电脑、手机或智能终端硬件设计经验的优先。"
        ]
    },
    {
        name: "算法工程师（cv/机器学习）",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责图像/视频相关算法的研究与开发。包括：目标检测、像分类、图像分割、目标跟踪、视频语义分析、人脸识别与分析、车辆与行人的检测识别跟踪、OCR 算法、视频结构化算法等。",
            "负责图像理解、机器学习、深度学习等前沿技术的研发，结合实际应用场景，提供技术解决方案。",
        ],
        describe: [
            "计算机、模式识别、人工智能、统计学、电子信息类等专业，图像处理、模式识别、机器学习相关研究方向的硕士及以上学历。",
            "熟练掌握计算机视觉和图像处理相关基本算法。",
            "较强的算法实现能力，至少精通 C/C++/Python/Matlab 等编程语言中的一种。",
            "在顶级会议/期刊上发表过论文，相关国际比赛获奖，及持有相关专利者优先。",
        ]
    },
    {
        name: "机器人算法工程师（SLAM）",
        address: [2],
        kind1: 1,
        money: "9-42K",
        skills: [
            "负责机器人基于激光雷达、摄像头、IMU 等传感器的二/三维 SLAM 算法的应用。",
            "负责机器人在室内未知环境中的 SLAM 算法研发。",
            "负责总体运作系统设计工作，运用已有的算法完成系统构建和应用层的硬件通讯。",
            "负责 SLAM 导航系统的集成、调试、修改、测试和优化工作。"
        ],
        describe: [
            "电子、通信、自动化、计算机等相关专业本科及以上学历。",
            "熟悉SLAM、导航、路径规划、控制及目标识别技术。",
            "进行过相关运动控制器、驱动器或嵌入式系统开发经验者优先。 ",
            "Kaggle、Robocon、RoboMaster、恩智浦杯智能车竞赛等赛事获奖者优先 。",
        ]
    },
    {
        name: "项目经理",
        address: [1, 2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责项目的建设方案、立项。",
            " 根据市场和产品需求，制定整个项目的硬件，结构，设计，软件，测试等计划，测并合理分配给相应的人员。",
            "根据计划推动及跟踪项目进度，保证项目的顺利进行。",
            "有很强的沟通协调能力，包括项目内成员或跨部门等沟通和协做。",
            "总结项目实施的经验和教训，优化项目实施的流程、规范等。"
        ],
        describe: [
            "计算机及相关专业本科及以上学历，3年以上人工智能相关领域项目管理相关经验。",
            "熟悉敏捷开发等开发方式。",
            "良好的计划和执行能力、协调能力和人际沟通能力。 ",
            "积极主动，具备团队意识，具有高度的责任心，能够承受较强的工作压力。",
            "有PMP证书优先。"
        ]
    },
    {
        name: "机器人软件系统集成工程师",
        address: [2],
        kind1: 1,
        money: "10-45K",
        skills: [
            "参与 Linux/Android/Windows 平台下的智能设备/机器人的研发。",
            " 软件系统设计、移植和调试。",
        ],
        describe: [
            " 计算机、通信、电子等相关专业本科及以上学历。",
            "熟悉 C/C++ 或 C#，熟悉 Linux/window 系统的进程、线程开发，熟悉计算机体系架构或面向对象的编程，了解 python /MATLAB 的使用。 ",
            "熟练掌握 Qt/PyQt 等 UI 设计。 ",
            "具备图像处理知识和嵌入式平台开发经验者优先。",
        ]
    },
    {
        name: "机器人软件工程师",
        address: [2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "机器人底层控制系统软件架构设计开发。 ",
            " 机器人内部各功能模块嵌入式软件开发。",
            "传感器选型及嵌入式驱动编写、上位机驱动程序编写。 ",
            " 机器人功能方案制定与实现。"
        ],
        describe: [
            "电子、通信、自动化、计算机等相关专业本科及以上学历。",
            "熟练使用 C/C++，熟悉 Python，具备良好的编码习惯与文档规范。",
            " 熟悉 Linux， UCOSIII、FreeRTOS 等至少一种嵌入式实时操作系统。",
            "熟悉 ROS 机器人操作系统者优先，Robocon、Robomasters、电子设计大赛、飞思卡尔智能车等机器人竞赛获奖者优先。",
        ]
    },
    {
        name: "驱动开发工程师",
        address: [1],
        kind1: 1,
        money: "8-39K",
        skills: [
            "负责智能处理器平台的系统软件研发。",
            "独立开发Linux系统驱动程序。",
            "负责优化系统性能和可靠性。",
        ],
        describe: [
            "计算机、电子或自动化等相关专业本科及以上学历，3年以上驱动开发工作经验。",
            "熟练掌握C/ C++编程技能。",
            "精通ARM/X86系统架构和Linux内核，熟悉Linux系统接口和驱动的开发、熟悉Camera/LCD等视频前后端接口、熟悉PCIE/I2C/SPI等总线接口熟悉ARM平台SMMU架构和驱动。",
            "有SoC平台IP驱动和系统软件开发经验者优先。",
        ]
    },
    {
        name: "软件工程师（Android应用）",
        address: [2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "独立完成编码，参与独立模块与组件库的开发。 ",
            "负责手机客户端产品的开发及优化。",
        ],
        describe: [
            "计算机相关专业本科及以上学历，2年以上Android 项目开发经验。",
            "熟练Android的线程机制，网络编程、通信协议、UI框架。",
            "熟悉Android 开发平台架构和原理 熟悉系统核心机制，包括 SystemServer 启动过程、AMS、 WMS、 Binder 机制等。 ",
            "接入过多个平台SDK，对Android机型以及适配方面有丰富经验。",
            "有JNI开发经验或熟悉JNI者优先，有产品上线经验者优先，参与过超过30人项目开发，有team leader 工作经验者优先。"
        ]
    },
    {
        name: "机器人硬件工程师",
        address: [2],
        kind1: 1,
        money: "8-39K",
        skills: [
            "根据公司机器人产品需求规划设计硬件方案。  ",
            "根据硬件方案，进行传感器、处理器等关键器件选型。 ",
            "根据硬件方案进行 PCB 设计、BOM 表生成及成本功能评估，并完成 PCB 生产流程。 ",
            "负责 PCB 打样焊接及测试。"
        ],
        describe: [
            " 电子、通信、自动化、计算机等相关专业本科及以上学历。",
            "熟悉基于 ARM 平台的 STM32 系列硬件的开发。 ",
            "熟悉基本逻辑电路、运放、有刷/无刷电机驱动、稳压电路等硬件选型及设计。 ",
            "熟悉常用 IIC、CAN、SPI、USART、RS232/485 等通信协议。 ",
            "具有以下经验者优先：多层 PCB 板实际开发，具备 IMU、电压电流检测、TOF 距离测量等传感器硬件设计，参加过机器人竞赛并获奖。"
        ]
    },
    {
        name: "嵌入式软件工程师（Android应用）",
        address: [1],
        kind1: 1,
        money: "8-39K",
        skills: [
            " 负责 Android 底层和 HAL 层优化和开发。  ",
            "负责 Android Native Framework层的优化和开发。 ",
            "负责 Android App Framework层的优化和开发。",
            "负责 Android 整机（含 Linux Kernel）系统移植、裁减，性能调优，故障分析、定位。"
        ],
        describe: [
            "本科及以上学历，5年以上 Android 底层和驱动开发经验。",
            "熟悉主流嵌入式处理器平台，有相关Android BSP 移植，Kernel 和 Driver 开发经验。",
            "熟练掌握 C/C++，数据结构，算法及 Linux Kernel 相关知识。",
            "熟悉 Android Framework，Graphic 原理。 ",
            "有内存优化，功耗优化，系统性能优化方面经验。"
        ]
    },
    {
        name: "软件工程师（Android应用）",
        address: [1],
        kind1: 1,
        money: "8-39K",
        skills: [
            "独立完成编码，参与独立模块与组件库的开发。",
            "负责手机客户端产品的开发及优化。",
        ],
        describe: [
            "计算机相关专业本科及以上学历，2年以上Android 项目开发经验。",
            "熟练Android的线程机制，网络编程、通信协议、UI框架。",
            "熟悉Android 开发平台架构和原理 熟悉系统核心机制，包括 SystemServer 启动过程、AMS、 WMS、 Binder 机制等。 ",
            "接入过多个平台SDK，对Android机型以及适配方面有丰富经验。",
            "有JNI开发经验或熟悉JNI者优先，有产品上线经验者优先，参与过超过30人项目开发，有team leader 工作经验者优先。"
        ]
    },

    {
        name: "质量保证工程师",
        address: [1, 2],
        kind1: 2,
        money: "8-39K",
        skills: [
            "负责机器人、智能门禁、智能猫眼及智慧电子类产品的质量保证工作。",
            "参与新项目评审、图纸评审确认；参与研发样品封样的确认和签核，负责新项目、新工艺、新材料的试验验证工作，出具试验结果，并针对试验验证过程及结果提出质量改进建议。",
            "负责先期质量问题的跟踪解决，进行质量攻关，督促和协调各部门解决质量问题的进度。",
            "跟进各阶段的试产，并对试产过程中出现的问题（NCP）进行汇总，以及跟踪问题点的关闭与否和对改善效果的确认。",
            "跟踪生产质量，推动相关部门对生产重大品质不良的分析与改善，产线出线异常时，协助安排验证评估风险。主导EVT、DVT、MP各阶段品质异常分析改善。"
        ],
        describe: [
            "计算机、电子、通信或自动化等相关专业本科及以上学历，5年及以上相关经验。",
            "熟悉一般电子产品FAT， SAT程序。",
            "熟练操作办公自动化、数据分析等专业软件，以及具有一定的检具使用及管理技能。",
            "熟悉ISO体系（ISO9001/14000/18000等），了解IEC、ITSS、CMMI、CCC、UL、TUV等相关质量及认证体系；有建立和改进公司内部审计制度、SCM、客户资质管理、服务质量管理系统等的经验。",
            "有国内外普遍认可的ISO内部审计员、PM/QM资质认证证书者优先考虑。",
            "熟悉各种管理工具，了解APQP、 FMEA、 MSA、 PPAP、SPC管理工具的实施细节，有QC7大手法的应用经验。"
        ]
    },
    {
        name: "结构工程师",
        address: [1, 2],
        kind1: 2,
        money: "8-39K",
        skills: [
            "负责公司产品结构的研发设计工作。",
            "负责新产品开发中各个阶段的评审，试模、试产工作。",
            "为EMI、ESD、安全和可靠性等测试提供结构支持。",
            "负责产品维护、出相关产品技术资料（BOM\检验图）及签板，结案资料完整准确。",
        ],
        describe: [
            "机械设计与制造等相关专业本科及以上学历，3年以上相关工作经验。",
            "熟练掌握塑料件、钣金件、压铸件的结构设计、生产工艺，各种表面处理。",
            "熟练运用Pro/E或UG及AutoCAD等相关绘图软件，能够熟练转工程图及确定检验标准。",
            "有智能产品、机器人等设计经验优先/14000/18000等），了解IEC、ITSS、CMMI、CCC、UL、TUV等相关质量及认证体系；有建立和改进公司内部审计制度、SCM、客户资质管理、服务质量管理系统等的经验。",
        ]
    },

    {
        name: "高级产品经理",
        address: [1, 2],
        kind1: 3,
        money: "10-45K",
        skills: [
            "完成人工智能产品的业务方需求分析、产品规划、功能和原型设计。",
            "推动产品的开发与发布，与内外部协调推进，对产品的数据进行分析形成相关结论。",
            "负责撰写产品文档、分析报告和汇报材料，对产品进行持续优化和改进。",
            "协助市场人员进行产品营销。",
        ],
        describe: [
            "本科及以上学历，3年以上相关工作经验。",
            "对人工智能产品有深刻的理解、独特的分析和洞察力，对市场动态变化敏感，能够快速发现和收集各渠道有价值的信息来源，形成产品需求。",
            "性格开朗，逻辑清晰，积极主动，执行力和沟通能力强。",
            "熟练运用PPT、Excel、Axure、Visio等工具。",
        ]
    },
    {
        name: "设计工程师（UI）",
        address: [1, 2],
        kind1: 4,
        money: "7-36K",
        skills: [
            "负责公司移动端、PC端、web端产品的UI/UX设计。",
            "紧跟设计流行趋势，制定设计规范，提升及优化UI用户体验。",
            "为运营需求提供设计支持，主要包括海报、banner、产品样册等。",
        ],
        describe: [
            "视觉传达及相关专业本科及以上学历，2年以上UI设计工作经验。",
            "掌握 UI/UX 设计规范技巧，熟悉Web和移动端的设计规范及设计趋势。",
            "参与并设计过至少两款上线并经过版本迭代的移动端或pc端产品。",
            "熟练使用 Photoshop 、illustrator、Sketch等设计软件，了解 invision、Flinto、Origami、AE等交互或动效工具。",
            "有丰富的动效作品设计经验及优秀的插画、2.5D设计作品者优先。",
        ]
    },
    {
        name: "电商运营经理",
        address: [1],
        kind1: 5,
        money: "10-45K",
        skills: [
            "根据公司战略，制定公司品牌线上总体定位，负责国内电商平台的总体规划、搭建、运营；制定电商（天猫、京东、易购、微商城等）整体运营策略、产品策略、推广策略；对销售业绩指标负责。",
            "负责店铺版面，标题文案，产品管理，库存管理等，对电商的日常数据负责，包括流量、点击率、转化率、复购率等，并形成报表和提出改进策略。",
            "通过数据库挖掘和市场分析，挖掘潜在目标客户的特征与属性，建立客户分层，并制定相应的精准营销策略。",
            "整理分析运营的各项数据，及时撰写店铺运营分析报告，并提出合理化解决方案。",
            "协调设计、推广、客服进行店铺内日常运营工作开展，管理平台营销预算。",
            "负责监控周、月及季度运营结果，发现问题及时查处，对销售和利润目标负责。"
        ],
        describe: [
            "本科以上学历，5年以上电商运营管理经验，拥有丰富消费电子、智能终端、服务机器人类似产品的电商运营经验者优先考虑。",
            "较强买家洞察能力、产品迭代能力、营销策划能力和规划能力。",
            "有较综合的运营方法论积累和团队管理经验，有带领并培养优秀运营团队的经验者优先。",
            "熟悉电商营销推广工具、具有较强的数据分析能力，能分析各种店铺统计软件的数据，以数据驱动运营。",
            "工作态度积极主动，责任心强，具备项目工作整体把控能力，以结果为导向，达成项目目标。有创业精神，敢于尝试和探索新的营销渠道和方法，能承担创业型企业快速成长的要求和较强的工作压力。",
            "至少精通京东或者阿里系任一电商品台运营，有成功电商运营经验，过往年销售业绩在5千万以上。",
        ]
    },
    {
        name: "库存管理及物流关务工程师",
        address: [1],
        kind1: 5,
        money: "面议",
        moneyKind: true, //
        skills: [
            "研发及生产用原材料（电子零件、模组类材料、结构件材料、测试用物料、包材类等）、研发样机库存管理。",
            "根据仓库管理制度，对库存做到帐目清晰、定期进行仓库盘点，确保库存数据的正确性。",
            "仓储合理规划及管理、根据产品入库，销售订单发货制定合理的发货方案，控制物流成本、提高物流发货质量。",
            "整机组装工厂及成型工厂交期跟进。",
            "确认生产原料需求计划。",
            "负责空运、海运、陆运以及异地海关申报和物流操作；安排产品的出口发货, 报关资料的对接与跟进。",
            "负责处理进出口清关以及跟踪整个流程以确保按时交付。"
        ],
        describe: [
            "本科及以上学历，企业管理、物流管理、质量管理等相关专业，3年以上相关工作经验。",
            "熟练运用PPT、Excel、Word、ERP等办公软件,熟悉ISO9001质量管理体系运作。",
            "熟悉外贸、物流、报关的工作流程，熟悉各种商品归类知识，精通有关进、出口政策和法规。",
        ]
    },
    {
        name: "人力资源经理",
        address: [2],
        kind1: 6,
        money: "9-42K",
        skills: [
            "为组织发展提供人力资源支持，定期进行组织盘点，在招聘、培训、绩效考核、薪酬、员工关系等方面为业务部门提供有效的解决方案并实施。",
            "候选人简历的筛选、挖掘，面试预约及面试过程的组织、实施、记录、跟踪面试结果。",
            "评估各类人才的使用情况，更新和维护人才储备库。",
            "协助建立公司职位流动和晋升体系；有经验者优先。",
            "负责来客接待工作。",
            "传承公司文化，发扬价值观，建设沟通渠道，保证组织的持续健康成长。"
        ],
        describe: [
            "本科以上学历，人力资源相关专业。",
            "具备5年以上人事管理工作经验。",
            "具备强烈的责任感，事业心，优秀的沟通能力，耐心、细心，以及严谨的逻辑思维能力。",
            "熟练使用办公软件；熟悉人力资源系统以及了解劳动合同法及相关人事政策法规。",
            "良好的团队合作精神，品行端正，有亲和力，具有很强的判断和决策能力，计划和协调能力，组织和公关能力。",
            "具有一定的人力资源管理或企业管理经验，能独立制定绩效考核方案及进行制度、流程。",
            "具有扎实的文字功底；能撰写或校对重要文字资料。"
        ]
    },
    {
        name: "市场拓展经理",
        address: [1, 2],
        kind1: 7,
        money: "10K-25K",
        skills: [
            "负责公司在烟台、山东及全国的系列智能产品的市场拓展，根据客户的业务合作需求制定商业解决方案，落地、推广。",
            "负责新项目的市场调研、商务方案制定、实施协调落地。",
        ],
        describe: [
            "本科及以上学历，EXCEL、PPT等办公软件运用娴熟，英文可以交流，技术背景优先。",
            "5年以上市场拓展经验，对智能产品市场有了解。",
            "对智慧安防、智慧园区、智能教育、智能机器人等新兴战略行业有所了解。",
            "熟悉智能软硬件生态链的对外合作流程。",
            "具备极强的抗压能力、责任心意识，工作认真，渴望置身于AI行业。"
        ]
    },
]


export default offers


// WEBPACK FOOTER //
// ./src/store/offers.js